import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// ========== PRODUCTS API ==========

export const fetchProducts = async (category = null) => {
  const params = category ? { category } : {};
  const { data } = await axios.get(`${API}/products`, { params });
  return data;
};

export const fetchProduct = async (productId) => {
  const { data } = await axios.get(`${API}/products/${productId}`);
  return data;
};

export const createProduct = async (productData) => {
  const { data } = await axios.post(`${API}/products`, productData);
  return data;
};

export const updateProductApi = async (productId, updates) => {
  const { data } = await axios.put(`${API}/products/${productId}`, updates);
  return data;
};

export const deleteProductApi = async (productId) => {
  const { data } = await axios.delete(`${API}/products/${productId}`);
  return data;
};

// ========== CHECKOUT API ==========

export const createCheckoutSession = async (items, originUrl, customerEmail = null, promoCode = null) => {
  const payload = {
    items: items.map(item => ({
      product_id: item.id,
      size: item.size,
      quantity: item.quantity,
    })),
    origin_url: originUrl,
    customer_email: customerEmail,
    promo_code: promoCode,
  };
  const { data } = await axios.post(`${API}/checkout/session`, payload);
  return data;
};

export const validatePromoCode = async (code, subtotal) => {
  const { data } = await axios.post(`${API}/promo/validate`, { code, subtotal });
  return data;
};

export const newsletterSignup = async (email) => {
  const { data } = await axios.post(`${API}/newsletter/signup`, { email });
  return data;
};

export const getMaintenanceStatus = async () => {
  const { data } = await axios.get(`${API}/maintenance/status`);
  return data;
};

export const toggleMaintenance = async (enabled, message = null) => {
  const { data } = await axios.post(`${API}/maintenance/toggle`, { enabled, message });
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/checkout/status/${sessionId}`);
  return data;
};

// ========== ORDERS API ==========

export const fetchOrders = async () => {
  const { data } = await axios.get(`${API}/orders`);
  return data;
};

export const fetchOrderBySession = async (sessionId) => {
  const { data } = await axios.get(`${API}/orders/session/${sessionId}`);
  return data;
};

// ========== CART HELPERS (localStorage) ==========
// Cart stays in localStorage since users don't have accounts yet

export const getCart = () => {
  const cart = localStorage.getItem('turnt_cart');
  return cart ? JSON.parse(cart) : [];
};

export const addToCart = (product, size) => {
  const cart = getCart();
  const existingItem = cart.find(item => item.id === product.id && item.size === size);

  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    cart.push({
      ...product,
      size,
      quantity: 1,
      cartId: `${product.id}-${size}-${Date.now()}`,
    });
  }

  localStorage.setItem('turnt_cart', JSON.stringify(cart));
  return cart;
};

export const updateCartItem = (cartId, quantity) => {
  const cart = getCart();
  const item = cart.find(item => item.cartId === cartId);

  if (item) {
    item.quantity = quantity;
    localStorage.setItem('turnt_cart', JSON.stringify(cart));
  }

  return cart;
};

export const removeFromCart = (cartId) => {
  let cart = getCart();
  cart = cart.filter(item => item.cartId !== cartId);
  localStorage.setItem('turnt_cart', JSON.stringify(cart));
  return cart;
};

export const clearCart = () => {
  localStorage.removeItem('turnt_cart');
  return [];
};
